<div class="modal-content">
  <div id="report">
    <div class="modal-header" ngbAutofocus tabindex="-1">
      <h1 class="modal-title">
        <div *ngIf="isSpecies()">
          Summary of Dealer Purchase <span *ngIf="isPaq()">AQ </span>Reports by Species
        </div>
        <div *ngIf="isIndustry()">
          Commercial Marine Dealer Industry Purchase Report Summary by non-Aquarium Species  (As of {{report.createdOn}})
        </div>
      </h1>
    </div>
    <div class="modal-body">
      <div class="row">
        <table class="table table-bordered table-responsive-sm fixed-layout">
          <thead class="thead-dark">
            <th *ngIf="isSpecies()">Month</th>
            <th>Species</th>
            <th class="text-right">No. Fishers</th>
            <th class="text-right">Pieces Purchased</th>
            <th class="text-right" *ngIf="!isPaq()">Lbs. Purchased</th>
            <th class="text-right">Value</th>
            <th class="text-right">Avg. Price</th>
            <th class="text-right" *ngIf="!isPaq()">Avg. Weight</th>
          </thead>
          <ng-container *ngFor="let recordsMap of report.details | keyvalue">
            <ng-container *ngFor="let record of recordsMap.value; let i=index">
              <tr *ngIf="isIndustry() && (i == 0)">
                <td colspan="5">
                  <strong>{{recordsMap.key}}</strong>
                </td>
              </tr>
              <tr>
                <ng-container *ngIf="isSpecies()">
                  <td><ng-container *ngIf="i == 0">{{record.yearMonth}}</ng-container></td>
                </ng-container>
                <td><span class="ml-2">{{record.species}}</span></td>
                <td class="text-right">{{record.fisherNo | number}}</td>
                <td class="text-right">{{0 == record.piecesPurchased ? '--' : record.piecesPurchased | number}}</td>
                <td class="text-right" *ngIf="!isPaq()">{{0 == record.lbsPurchased ? '--' : record.lbsPurchased | number : '1.2-2'}}</td>
                <td class="text-right">{{record.amount | bigCurrency}}</td>
                <td class="text-right">{{0 == record.avgPrice ? '--' : record.avgPrice | bigCurrency}}</td>
                <td class="text-right" *ngIf="!isPaq()">{{0 == record.avgWeight ? '--' : record.avgWeight | number : '1.2-2'}}</td>
              </tr>
            </ng-container>
          </ng-container>
          <tr class="lead">
            <td>TOTAL</td>
            <td *ngIf="isSpecies()"></td>
            <td class="text-right">{{report.fisherNumber | number}}</td>
            <td class="text-right">{{report.piecesPurchased | number}}</td>
            <td class="text-right" *ngIf="!isPaq()">{{report.lbsPurchased | number : '1.2-2'}}</td>
            <td class="text-right">{{report.amount | bigCurrency}}</td>
            <td class="text-right"></td>
            <td class="text-right" *ngIf="!isPaq()"></td>
          </tr>
        </table>
      </div>
    </div> <!-- modal-body-->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn" (click)="onExport()">
      <i class="fas fa-save"> </i> Export
    </button>
    <button type="button" class="btn btn-primary btn" (click)="onPrint()">
      <i class="fas fa-print"> </i> Print
    </button>
    <button type="button" class="btn btn-secondary btn" (click)="onCancel()">
      <i class="fas fa-times"> </i> Return to Reports
    </button>
  </div>
</div>
